module.exports = __webpack_public_path__ + "assets/1a1d0ccb192c07e52253c415afb0376e.jpg";